module.exports = __webpack_public_path__ + "media/color.83044504.mp4";